<script setup>
import {usePortalContentAndDesignStore} from "../../../stores/partners/portalContentAndDesignStore";
import LiveDesigner from "../live-designer/LiveDesigner.vue";
import {computed} from "vue";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const backgroundImage = computed(
    () => portalContentAndDesignStore.srcRoutes.public_page_background_image
);

const computedClasses = computed(() => {
    let classes = ["flex"];

    if (portalContentAndDesignStore.getPageBackgroundGradientColorClass) {
        classes.push(portalContentAndDesignStore.getPageBackgroundGradientColorClass);
    }

    if (backgroundImage.value && backgroundImage.value !== portalContentAndDesignStore.getFileUploadNoImageRoute) {
        classes.push("bg-cover bg-center");
    }

    return classes;
});

// Computed styles (for dynamic background images)
const computedStyles = computed(() => {
    let styles = {};

    if (
        (portalContentAndDesignStore.signupPageSettings?.signup && portalContentAndDesignStore.signupPageSettings?.signup === "none") ||
        (!portalContentAndDesignStore.signupPageSettings?.signup && portalContentAndDesignStore.portalLayoutSettings.portal_signup_sidebar_side === "none")
    ) {
        if (backgroundImage.value && backgroundImage.value !== portalContentAndDesignStore.getFileUploadNoImageRoute) {
            styles.backgroundImage = `url(${backgroundImage.value})`;
        }
    }

    return styles;
});

</script>

<template>
    <div
        v-if="portalContentAndDesignStore.portalInitialized"
        :class="[
            'flex',
            computedClasses,
            portalContentAndDesignStore.getPageBackgroundColorClass
         ]"
        :style="computedStyles"
        v-cloak
    >
        <live-designer v-if="portalContentAndDesignStore.liveDesignerEnabled" />

        <slot />

    </div>
</template>
